import React, { useState, useRef } from "react";
import { SlideDown } from "react-slidedown";
import SubBusinesses from "components/Navigation/SubBusinesses";
import useOutsideClick from "core/custom-hooks/useOutsideClick";
import "./SubBusinesses.scss";
import "./MobileHeader.scoped.scss";
import useStore from "core/custom-hooks/useStore";
import { useFormik } from "formik";
import * as Validations from "core/common/validations";
import * as Yup from "yup";
import * as Utils from "core/common/utils";
import { SUBBUSINESS_ID_LOCAL_STORAGE_KEY } from "core/common/constants/localstorage";
import { setCurrentBusiness } from "core/store/actionCreators";
import { openPopup } from "components/Popup/Popup";
import clsx from "clsx";
import * as TagManager from "core/common/seo/tagManager";
import ResetPassword from "../../ResetPassword/ResetPassword"

const MobileHeader = ({isActive,isRRH}) => {
    const ref = useRef();
    const { dispatch, state, businessRepository } = useStore();
    const { isAdmin, popup } = state;
    const { isOpen: popupIsOpen } = popup;

    const formRef = useRef();
    const [shouldShowSubMenus, setShouldShowSubMenus] = useState(false);
    const [isSearch, setIsSearch] = useState(false);
    const { business } = state;
    


    useOutsideClick(ref, () => {
        if (shouldShowSubMenus) {
            setShouldShowSubMenus(false);
        }
    });

    const handleSubmit = async ({ businessNumber }) => {
        try {
            Utils.loadingWrapper(dispatch, async () => {

                const { data: responseData } = await businessRepository.get(businessNumber);
                const { data } = responseData || {};

                if (Utils.isSuccessfulRequest(dispatch, responseData, true)) {
                    TagManager.sendBusinessId(businessNumber);
                    localStorage.setItem(SUBBUSINESS_ID_LOCAL_STORAGE_KEY, businessNumber);
                    localStorage.removeItem("link-ofir")
                    dispatch(setCurrentBusiness(data));
                    setIsSearch(false);
                    formRef.current?.blur();
                    formik.resetForm();
                }

            });
        } finally { }
    };

    const formik = useFormik({
        initialValues: {
            businessNumber: ""
        },
        validationSchema: Yup.object({
            businessNumber: Validations.businessNumber
        }),
        onSubmit: handleSubmit,
    });

    const handleErrorSubmit = (e) => {
        e.preventDefault();
        const { errors } = formik;
        const { businessNumber: businessNumberError } = errors;
        !popupIsOpen && businessNumberError && openPopup(dispatch, "בחירת עסק", businessNumberError);
    };

    const { isValid, values } = formik;
    const { businessNumber } = values;

    if (!business) {
        return null;
    }

    const { business_id, sub_bussnisses } = business;
    const hasSubBusinesses = Array.isArray(sub_bussnisses) && sub_bussnisses.length > 1;
    const name = sub_bussnisses?.find(x => x.business_id === business_id)?.name || business?.name;


    const goldenTagNames =
    business?.goldenCustomer?.minisites
      ?.filter(ms => ms.isGolden === true)
      .map(ms => ms.tagName) ?? [];

    return (
        <div className="business_details_watch_area">
            <div className={`business_details_plumbin_ltd_wrap only_mobile_view ${!isActive || isRRH ? 'm_search_not_active': ''}`}>
                {isAdmin && !isSearch && <ResetPassword isMobile={true} />}
                {
                    isSearch &&
                    <div className="business_details_search">
                        <form className="no-arrows" onSubmit={isValid ? formik.handleSubmit : (e) => handleErrorSubmit(e)}
                            ref={el => { formRef.current = el; }}>
                            <input
                                tabIndex="1"
                                type="tel"
                                placeholder="הזן מספר עסק"
                                onKeyUp={(e) => e.key === 13 && formRef.current.submit()}
                                {...formik.getFieldProps("businessNumber")} />
                            {
                                businessNumber && businessNumber.length && (
                                    <button id="search" type="submit">
                                        <i className="fa fa-long-arrow-left"></i>
                                    </button>
                                )
                            }
                        </form>

                        <a href="/" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setIsSearch(false); }}>
                            <i className="fa fa-times-circle"></i>
                        </a>
                    </div>
                }
                <div onClick={() => { hasSubBusinesses && setTimeout(() => setShouldShowSubMenus(!shouldShowSubMenus)) }}>
                    {
                        !isSearch &&
                        <>
                            <a href="/" onClick={(e) => { e.preventDefault(); }} className="plumbin_btn">
                                {name}

                                {hasSubBusinesses && <i className={clsx("fa", "fa-chevron-down", "rotate_180_0", shouldShowSubMenus && "rotate_180_180")}></i>}
                            </a>
                             {goldenTagNames.length > 0 &&  
                           <svg className="top-buissnes-svg" width="44" height="54" viewBox="0 0 44 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <g filter="url(#filter0_d_4891_35869)">
                               <path d="M4 4C4 1.79087 5.79086 0 8 0H35.3846C37.5938 0 39.3846 1.79086 39.3846 4V34.2499C39.3846 35.7334 38.5637 37.095 37.2518 37.7874L23.5595 45.0145C22.3911 45.6312 20.9935 45.6312 19.8252 45.0145L6.13285 37.7874C4.82095 37.095 4 35.7334 4 34.2499V4Z" fill="white"/>
                           </g>
                           <path d="M6.65381 7.65918C6.65381 5.45004 8.44467 3.65918 10.6538 3.65918H32.7307C34.9399 3.65918 36.7307 5.45004 36.7307 7.65918V32.0645C36.7307 33.5543 35.9028 34.9206 34.5822 35.6102L23.5437 41.3742C22.3837 41.9799 21.0008 41.9799 19.8408 41.3742L8.80233 35.6102C7.48175 34.9206 6.65381 33.5543 6.65381 32.0645V7.65918Z" fill="white"/>
                           <g filter="url(#filter1_i_4891_35869)">
                               <path d="M32.3853 16.2703C32.3863 14.5405 31.9401 12.8386 31.0882 11.3225C30.2363 9.80643 29.0063 8.5254 27.5123 7.59841C26.0184 6.67141 24.309 6.12852 22.543 6.02016C20.777 5.9118 19.0116 6.24148 17.4109 6.97858C15.8101 7.71569 14.4258 8.8363 13.3866 10.2363C12.3475 11.6364 11.6871 13.2704 11.4669 14.9867C11.2467 16.703 11.4737 18.4459 12.127 20.0535C12.7802 21.661 13.8385 23.0811 15.2034 24.1819V33.0662C15.2033 33.2254 15.2448 33.3819 15.324 33.5209C15.4033 33.6599 15.5175 33.7769 15.656 33.8605C15.7944 33.9442 15.9525 33.9919 16.1151 33.9991C16.2778 34.0062 16.4396 33.9726 16.5851 33.9014L21.8853 31.3166L27.1866 33.9072C27.3195 33.9692 27.4652 34.0008 27.6125 33.9993C27.8657 33.9993 28.1085 33.901 28.2875 33.726C28.4665 33.551 28.5671 33.3137 28.5671 33.0662V24.1819C29.7614 23.2203 30.7231 22.0123 31.3832 20.6444C32.0434 19.2765 32.3856 17.7827 32.3853 16.2703ZM13.2943 16.2703C13.2943 14.6093 13.7982 12.9857 14.7422 11.6046C15.6862 10.2236 17.0279 9.14719 18.5977 8.51157C20.1674 7.87595 21.8948 7.70964 23.5613 8.03368C25.2277 8.35771 26.7585 9.15754 27.9599 10.332C29.1614 11.5065 29.9796 13.0029 30.3111 14.6319C30.6426 16.261 30.4724 17.9495 29.8222 19.484C29.172 21.0186 28.0709 22.3302 26.6581 23.2529C25.2453 24.1757 23.5844 24.6683 21.8853 24.6683C19.6076 24.6658 17.4239 23.7802 15.8134 22.2058C14.2028 20.6314 13.2969 18.4968 13.2943 16.2703ZM15.2034 16.2703C15.2034 14.9784 15.5953 13.7156 16.3295 12.6414C17.0637 11.5673 18.1073 10.7301 19.3282 10.2357C20.5492 9.74135 21.8927 9.612 23.1888 9.86403C24.485 10.1161 25.6755 10.7382 26.61 11.6516C27.5445 12.5651 28.1809 13.729 28.4387 14.996C28.6965 16.263 28.5642 17.5764 28.0584 18.7699C27.5527 19.9634 26.6963 20.9835 25.5975 21.7012C24.4987 22.419 23.2068 22.802 21.8853 22.802C20.1137 22.8002 18.4153 22.1114 17.1626 20.8869C15.9099 19.6623 15.2053 18.002 15.2034 16.2703Z" fill="#DFA800"/>
                           </g>
                           <defs>
                               <filter id="filter0_d_4891_35869" x="0" y="0" width="43.3848" height="53.4771" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                   <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                   <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                   <feOffset dy="4"/>
                                   <feGaussianBlur stdDeviation="2"/>
                                   <feComposite in2="hardAlpha" operator="out"/>
                                   <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
                                   <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4891_35869"/>
                                   <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4891_35869" result="shape"/>
                               </filter>
                               <filter id="filter1_i_4891_35869" x="11.3853" y="6" width="21" height="29" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                   <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                   <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                                   <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                   <feOffset dy="1"/>
                                   <feGaussianBlur stdDeviation="0.5"/>
                                   <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                                   <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                   <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4891_35869"/>
                               </filter>
                           </defs>
                           </svg> }

                            {
                                isAdmin &&
                                <a href="/" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setIsSearch(true); }} className="business_details_search_btn">
                                    <i className="fa fa-search"></i>
                                </a>
                            }
                        </>
                    }
                </div>

              

                <div className="business_details_plumbin_menu_wrap only_mobile_view">
                    <SlideDown ref={ref} className="my-dropdown-slidedown business_details_plumbin_menu">
                        {
                            shouldShowSubMenus && !isSearch &&
                            <SubBusinesses shouldShowCurrentBusiness={false} isMobile={true} mainClass="business_details_plumbin_menu_ul" />
                        }
                    </SlideDown>
                </div>
            </div>
        </div>
    );
}

export default MobileHeader;